import angular, { ITemplateCacheService } from 'angular';

const formThemesModule = angular
  .module('flowingly.runner.formthemes', [])
  .component('formThemes', {
    templateUrl: 'Client/runner.formthemes/runner.formtheme.tmpl.html',
    controller: class FormThemesController {}
  });

formThemesModule.run([
  '$templateCache',
  ($templateCache: ITemplateCacheService) => {
    $templateCache.put(
      'Client/runner.formthemes/runner.formtheme.tmpl.html',
      require('./runner.formtheme.tmpl.html').default
    );
  }
]);
export default formThemesModule;
